import { returnAction } from '../return-action.util';
import { ActionEnum } from '../../../enum/action.enum';
import { IUpdateFontsPayload } from '../../../action/settings.action';
import { ISettingsFont } from '../../../interface/settings.interface';

export const updateFonts = (fonts: ISettingsFont[]) => returnAction<IUpdateFontsPayload>(ActionEnum.SETTINGS_UPDATE_FONTS, {fonts});
